var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 64,
    viewBox: "0 0 86 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2067_10113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.50023,
    y: 8.50023,
    width: 69.0312,
    height: 47.0212,
    rx: 5.50248,
    fill: "#1F72CD",
    stroke: "#D9D9D9",
    strokeWidth: 1.00045
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.555 25.0078L14.0027 39.5078H21.8467L22.8191 37.1959H25.0419L26.0143 39.5078H34.6484V37.7433L35.4177 39.5078H39.884L40.6533 37.706V39.5078H58.6098L60.7933 37.256L62.8377 39.5078L72.0606 39.5265L65.4876 32.2983L72.0606 25.0078H62.9808L60.8553 27.2181L58.8752 25.0078H39.3409L37.6635 28.7504L35.9467 25.0078H28.1191V26.7123L27.2483 25.0078H20.555ZM47.3691 27.0672H57.6806L60.8344 30.4739L64.0898 27.0672H67.2436L62.4518 32.2966L67.2436 37.4658H63.9468L60.793 34.0195L57.5209 37.4658H47.3691V27.0672ZM49.9152 31.1198V29.2204V29.2186H56.3492L59.1567 32.2562L56.2248 35.3103H49.9152V33.2368H55.5405V31.1198H49.9152ZM22.0726 27.0672H25.8961L30.2423 36.8997V27.0672H34.4308L37.7877 34.1171L40.8815 27.0672H45.0491V37.4719H42.5132L42.4925 29.3188L38.7954 37.4719H36.5269L32.8091 29.3188V37.4719H27.5922L26.6032 35.1393H21.2598L20.2728 37.4699H17.4777L22.0726 27.0672ZM22.1722 32.9831L23.9326 28.8278L25.691 32.9831H22.1722Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2067_10113",
    x: 0.437531,
    y: 0.437531,
    width: 85.1564,
    height: 63.1464,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78123
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2067_10113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2067_10113",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/Amex.cf7db5ebce962a733bbdc43f28da3561.svg";
export { ForwardRef as ReactComponent };